import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { CHECKBOX_KEYS } from '../constants'
import {
  getCategoryLegalFormAdjusted,
  getCompanyStatus,
  postDomesticSearch,
  postDomesticSearchCount,
} from './thunk'

const slice = createSlice({
  name: 'domesticSearch/searchList',
  initialState: {
    data: [],
    countData: {},
    isLoading: true,
    totalRecords: 0,
    totalPage: 0,
    page: 1,
    pageSize: 10,
    checkedOptions: {},
    textSearch: undefined,
    filter: {
      legalForm: [],
      activeStatus: [],
    },
  },
  reducers: {
    changePageSize: (state, action) => {
      state.pageSize = action.payload
      state.page = 1
    },
    changePage: (state, action) => {
      state.page = action.payload
    },
    changeCheckedOptions: (state, action) => {
      state.checkedOptions = { ...state.checkedOptions, ...action.payload }
    },
    changeTextSearch: (state, action) => {
      state.textSearch = action.payload
    },
    reset: (state) => {
      state.page = 1
      state.pageSize = 10
      state.checkedOptions = {}
      state.textSearch = undefined
    },
    resetCheckedOptions: (state) => {
      state.checkedOptions = {}
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postDomesticSearch.pending, (state) => {
      state.isLoading = true
      state.data = []
      state.totalPage = 0
      state.totalRecords = 0
    })
    builder.addCase(postDomesticSearch.fulfilled, (state, { payload = {} }) => {
      state.data = payload.data || []
      state.totalPage = payload.totalPage || 0
      state.totalRecords = payload.totalRecords || 0
      state.isLoading = false
    })
    builder.addCase(postDomesticSearch.rejected, (state, action) => {
      state.isLoading = action.payload.isLoading
    })

    builder.addCase(
      postDomesticSearchCount.fulfilled,
      (state, { payload = {} }) => {
        let countData = {}
        Object.keys(payload).forEach((key) => {
          if (payload[key] && payload[key].length) {
            countData = {
              ...countData,
              ...payload[key].reduce((obj, item) => {
                return {
                  ...obj,
                  [`${key}-${item.id}`]: item.count,
                }
              }, {}),
            }
          }
        })

        state.countData = countData
      },
    )

    builder.addCase(
      getCategoryLegalFormAdjusted.fulfilled,
      (state, { payload = [] }) => {
        state.filter.legalForm = payload.map((item) => ({
          name: item.currentBusinessTypeName,
          value: item.currentBusinessTypeId,
          key: `${CHECKBOX_KEYS.LEGAL_FORM}-${item.currentBusinessTypeId}`,
        }))
      },
    )

    builder.addCase(getCompanyStatus.fulfilled, (state, { payload = [] }) => {
      state.filter.activeStatus = payload.map((item) => ({
        name: item.activeStatusName,
        value: item.activeStatusId,
        key: `${CHECKBOX_KEYS.STATUS}-${item.activeStatusId}`,
      }))
    })
  },
})

export const selectCountData = (state) => state[slice.name].countData
export const selectData = (state) => state[slice.name].data
export const selectLoading = (state) => state[slice.name].isLoading
export const selectTotalRecords = (state) => state[slice.name].totalRecords
export const selectTotalPage = (state) => state[slice.name].totalPage
export const selectPage = (state) => state[slice.name].page
export const selectPageSize = (state) => state[slice.name].pageSize
export const selectCheckedOptions = (state) => state[slice.name].checkedOptions
export const selectTextSearch = (state) => state[slice.name].textSearch
export const selectFilter = (state) => state[slice.name].filter

export const {
  changePageSize,
  changePage,
  changeCheckedOptions,
  changeTextSearch,
  reset,
  resetCheckedOptions,
} = slice.actions

register(slice.name, slice.reducer)
